import { Check } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { Parallax } from "../ui/Parallax";
import { DownloadCTA } from "../ui/DownloadCTA";
import { Wave, Spark } from "../ui/decor";

const PERKS = ["100% free, no subscription", "No card needed", "Works with any scale"];

export function FinalCTA() {
  return (
    <section id="about" className="relative overflow-hidden bg-teal-deep">
      {/* Melt up into the cream page above. */}
      <Wave fill="#FFF6EC" flip />

      {/* Playful floating accents on the flat teal block. */}
      <Spark
        fill="#FFC93C"
        className="absolute left-[6%] top-24 hidden h-10 w-10 animate-float sm:block"
      />
      <Spark
        fill="#FFF6EC"
        className="absolute bottom-28 right-[8%] hidden h-7 w-7 animate-wiggle lg:block"
      />

      <div className="container-x relative z-10 py-14 sm:py-20">
        <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          {/* Copy side */}
          <div>
            <Reveal>
              <h2 className="display text-4xl leading-[1.02] text-white sm:text-6xl">
                Your next weigh-in is{" "}
                <span className="marker text-navy">already earning.</span>
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/90">
                Losing weight is hard enough. FitBuddy makes sure every gram you
                lose finally counts for something you can spend. Download it free
                and feel the first payout today.
              </p>
            </Reveal>
            <Reveal delay={3}>
              <div className="mt-9">
                <DownloadCTA source="final" tone="onColor" />
              </div>
            </Reveal>
            <Reveal delay={4}>
              <ul className="mt-8 flex flex-wrap gap-3">
                {PERKS.map((perk, i) => (
                  <li
                    key={perk}
                    className={`sticker ${
                      i % 2 === 0 ? "rotate-1" : "-rotate-2"
                    }`}
                  >
                    <Check className="h-4 w-4" strokeWidth={3.5} aria-hidden />
                    {perk}
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>

          {/* Big tilted celebration photo — the hero of the final moment. */}
          <Reveal delay={2}>
            <Parallax distance={36} className="relative mx-auto w-full max-w-md lg:max-w-none">
              <div className="rotate-3 transition-transform duration-300 hover:rotate-1">
                <img
                  src="/photos/cta-celebrate.jpg"
                  alt="Someone celebrating a weigh-in win with their arms in the air"
                  className="aspect-[4/5] w-full rounded-[2rem] border-4 border-white object-cover shadow-[8px_8px_0_0_#FFC93C] sm:aspect-[5/4] lg:aspect-[4/5]"
                  loading="lazy"
                />
              </div>
              <Spark
                fill="#FFC93C"
                className="absolute -left-4 -top-5 h-12 w-12 -rotate-12"
              />
            </Parallax>
          </Reveal>
        </div>
      </div>

      {/* Melt back down into the cream page below. */}
      <Wave fill="#FFF6EC" />
    </section>
  );
}
